// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#kt_content{padding-top:2em!important}@media (min-width:1264px){.container{max-width:1440px}}@media (max-width:960px){.container{max-width:900px}}.h_iframe-aparat_embed_frame{position:relative;max-width:270px;aspect-ratio:16/9;margin-inline:auto}.h_iframe-aparat_embed_frame .ratio{display:block;width:100%;height:auto}.h_iframe-aparat_embed_frame iframe{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
